const FIELD_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT'])

interface ViewportDoc { activeElement: (Element & { blur?: () => void }) | null }
interface ViewportWin { scrollTo: (x: number, y: number) => void }

/**
 * iOS scrolls the page up to keep a focused field above the keyboard. When that field unmounts
 * (login success) the offset is never restored and the top bar stays hidden under the status bar,
 * so drop focus and scroll back to the top.
 */
export function resetViewportAfterKeyboard(doc: ViewportDoc = document, win: ViewportWin = window): void {
  const active = doc.activeElement
  if (active && FIELD_TAGS.has(active.tagName)) active.blur?.()
  win.scrollTo(0, 0)
}
